/// <reference path="../types/index.d.ts" />

import '../client_forms/rootkitchen/style.css';
import FormStructure from './rootkitchen/form_structure';

export default FormStructure;